// @flow

import React from 'react'
import { compose } from 'recompose'
import { Trans, withI18n } from '@lingui/react'

import withStyles from 'material-ui/styles/withStyles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'

import Section from 'components/Section'

type Props = {
  classes: Object,
  i18n: Object,
}

const TehnologijeSection = ({ classes, i18n }: Props) => (
  <Section className={classes.root} anchor={i18n._('tehnologije.slug')}>
    <Grid className={classes.container} container spacing={0}>
      <Grid className={classes.intro} item xs={12} sm={12} md={7} lg={7}>
        <Typography className={classes.title} variant={'headline'}>
          <Trans id='tehnologije.title' />
        </Typography>
        <Typography className={classes.lead} variant={'subheading'}>
          <Trans id='tehnologije.lead' />
        </Typography>
      </Grid>
      <Grid className={classes.content} item xs={12} sm={12} md={5} lg={5}>
        <Grid className={classes.grid} container spacing={0}>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/nodejs.svg')}
                alt={'NodeJS'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/gatsby.svg')}
                alt={'GatsbyJS'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/graphql.svg')}
                alt={'GraphQL'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/neo4j.svg')}
                alt={'Neo4j'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/react.svg')}
                alt={'ReactJS'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/bootstrap.svg')}
                alt={'Bootstrap'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/dotnet.svg')}
                alt={'.NET'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/oracle.svg')}
                alt={'Oracle'}
              />
            </div>
          </Grid>
          <Grid className={classes.column} item xs={4}>
            <div className={classes.imagewrap}>
              <img
                className={classes.image}
                src={require('./images/mysql.svg')}
                alt={'MySQL'}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Section>
)

const styles = theme => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
  container: {
    maxWidth: '1640px',
    margin: '0 auto',
  },

  intro: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    marginBottom: theme.spacing.unit * 2,
    color: theme.palette.common.white,
    maxWidth: '720px',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  lead: {
    color: theme.palette.common.white,
    maxWidth: '720px',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },

  content: {
    //
  },
  grid: {
    maxWidth: '566px',
    marginTop: theme.spacing.unit * 4,
    marginLeft: 'auto',
    marginRight: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
  },
  column: {
    position: 'relative',
    padding: theme.spacing.unit,
    '&:before': {
      content: '""',
      display: 'block',
      width: '100%',
      paddingBottom: '100%',
    },
  },
  imagewrap: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    right: '10px',
    bottom: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #fff',
  },
  image: {
    maxWidth: '75%',
  },
})

export default compose(
  withI18n(),
  withStyles(styles)
)(TehnologijeSection)



// WEBPACK FOOTER //
// ./src/components/Tehnologije/index.js